module.exports = __webpack_public_path__ + "static/media/1.64360f88.jpg";